$(document).on("click", ".new-pdp-prod-btn", function(){
  $(this).parents(".new-pdp-prod-card").addClass("active");
  $(this).parents(".new-pdp-prod-card").find(".new-pdp-prod-qty")[0].stepUp(1);
  updateBoxContent();
})

$(document).on("click", ".new-pdp-prod-qty-btn--plus", function(){
  $(this).parent().find(".new-pdp-prod-qty")[0].stepUp(1);
  updateBoxContent();
})

$(document).on("click", ".new-pdp-prod-qty-btn--minus", function(){
  $(this).parent().find(".new-pdp-prod-qty")[0].stepDown(1);
  updateBoxContent();
})

$(document).on("click", ".new-pdp-box-content-close", function(){
  $(`.new-pdp-prod-qty[data-id="${$(this).attr("data-id")}"]`).val(0);
  $(`.new-pdp-prod-qty[data-id="${$(this).attr("data-id")}"]`).parents(".new-pdp-prod-card").removeClass("active");
  updateBoxContent();
  $(this).remove();
})

$(document).on("click", ".new-pdp-box-header", function(){
  $(this).toggleClass("active");
  $(this).parents(".new-pdp-box-wrapper").find(".new-pdp-box-content-wrapper").toggleClass("active");
})

$(document).on("change", ".new-pdp-box-footer-selling-plan-select", function(){
  $(".new-pdp-box-footer-btn").attr("data-selling-plan", $(this).val());
  $(`.new-pdp-mobile-sp-inp[value="${$(this).val()}"]`)[0].checked = true;
})

function updateBoxContent(){
  let totalCount = 0;
  let totalPrice = parseFloat($(".new-pdp-box-footer-price").attr("data-price"));
  let moneyFormat = $(".new-pdp-box-footer-price").attr("data-money");
  let discount = parseInt($(".new-pdp-box-footer-price").attr("data-discount"));
  let limit = parseInt($(".new-pdp-wrapper").attr("data-limit"));
  $(".new-pdp-box-content-wrapper").empty();
  $(".new-pdp-prod-card.active").each(function(){
    let price = parseInt($(this).find(".new-pdp-prod-qty").val()) * parseFloat($(this).find(".new-pdp-prod-qty").attr("data-price"));
    let content = `<div class="new-pdp-box-content-item" data-id="${$(this).attr("data-id")}">
    <span class="new-pdp-box-content-close" data-id="${$(this).find(".new-pdp-prod-qty").attr("data-id")}">&#10005;</span>
    <img src="${$(this).find(".new-pdp-prod-card-img").attr("data-img")}" class="new-pdp-box-content-img" />
    <p class="new-pdp-box-content-title">${$(this).find(".new-pdp-prod-card-title").text()}
    <span>x ${$(this).find(".new-pdp-prod-qty").val()}</span>
    <span class="new-pdp-box-content-price">${Shopify.formatMoney(price, moneyFormat)}</span>
    </p>
    </div>`
    $(".new-pdp-box-content-wrapper").append(content);
    totalCount += parseInt($(this).find(".new-pdp-prod-qty").val());
    totalPrice += price;
  });
  $(".new-pdp-box-items-count").text(totalCount);
  if(discount > 0){
    let discountAmount = totalPrice * (discount / 100);
    let finalPrice = totalPrice - discountAmount;
    $(".new-pdp-box-footer-price strike").text(Shopify.formatMoney(totalPrice, moneyFormat));
    $(".new-pdp-box-footer-price em").text(Shopify.formatMoney(finalPrice, moneyFormat));
    $(".new-pdp-box-footer-price dd").text(Shopify.formatMoney(discountAmount, moneyFormat));
  }
  else{
   $(".new-pdp-box-footer-price em").text(Shopify.formatMoney(totalPrice, moneyFormat)); 
  }
  if(totalCount >= limit){
    $(".new-pdp-prod-card").addClass("disabled");
    $(".new-pdp-box-footer-btn").addClass("active");
  }
  else{
    $(".new-pdp-prod-card").removeClass("disabled");
    $(".new-pdp-box-footer-btn").removeClass("active");
  }
}

function resetBoxContent(){
  $(".new-pdp-box-content-wrapper").empty();
  $(".new-pdp-prod-qty:not(.new-pdp-prod-qty--chef)").val(0);
  $(".new-pdp-prod-card").removeClass("active");
  $(".new-pdp-prod-card").removeClass("disabled");
}

$(document).on("change", ".new-pdp-box-choice-input", function(){
  resetBoxContent();
  if($(this).val() == 'chef-choice'){
    $(".new-pdp-products-wrapper--chef .new-pdp-prod-card").addClass("active");
    // $(".new-pdp-products-wrapper--chef .new-pdp-prod-qty").val(1);
  }
  updateBoxContent();
  if($(this).val() == 'chef-choice'){
    $(".new-pdp-box-content-close").remove();
  }
})

$(document).on("click", ".new-pdp-box-footer-btn.active", function(){
  let $this = $(this);
  let arr = [];
  $this.addClass("active-loading");
  
  // ⭐ ADD THE EXTRA PRODUCT FIRST (ID: 40914461425700)
  // This product will be added but hidden from the cart drawer
  arr.push({
    'id': 40914461425700,
    'quantity': 1,
    'properties': {
      '_hidden': 'true'  // Custom property to identify this product
    }
  });
  
  if($(this).attr("data-selling-plan") != "none"){
    $(".new-pdp-prod-card.active").each(function(){
      arr.push({
        'id': $(this).attr("data-id"),
        'quantity': parseInt($(this).find(".new-pdp-prod-qty").val()),
        'selling_plan': $this.attr("data-selling-plan")
      })
    })
  }
  else{
    $(".new-pdp-prod-card.active").each(function(){
      arr.push({
        'id': $(this).attr("data-id"),
        'quantity': parseInt($(this).find(".new-pdp-prod-qty").val())
      })
    })
  }
  
  let formData = {
    'items': arr,
    sections: "cart-drawer,cart-icon-bubble"
  };
  
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(function(res){
    if(res.status){
      console.log("error");
    }
    else{
      const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
      const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
      
      // ⭐ REMOVE THE EXTRA PRODUCT FROM CART DRAWER BEFORE DISPLAYING
      // Find all cart items with variant ID 40914461425700 and remove them
      $(cartParsedData).find('cart-drawer-items').find('cart-drawer-item, .cart-item, [data-index]').each(function() {
        let $item = $(this);
        let itemHtml = $item.html();
        
        // Check multiple ways the variant ID might appear
        if (itemHtml && (
            itemHtml.includes('40914461425700') || 
            itemHtml.includes('variants/40914461425700') ||
            $item.attr('data-variant-id') === '40914461425700' ||
            $item.find('[data-variant-id="40914461425700"]').length > 0 ||
            $item.find('a[href*="40914461425700"]').length > 0
        )) {
          $item.remove(); // Remove this item completely
        }
      });
      
      $("cart-drawer.drawer").removeClass("is-empty");
      $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
      $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
      
      document.querySelector("#cart-icon-bubble").dispatchEvent(new Event('click'));
      $(".cart-count-bubble").trigger("click");
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(function(){
    $this.removeClass("active-loading");
  });
})

$(document).on("click", ".new-pdp-choice-mobile-wrapper span", function(){
  $(".new-pdp-choice-mobile-wrapper span").removeClass("active");
  $(this).addClass("active");
  let id = $(this).attr("data-id");
  if(id == 1){
    $(`label[for="new-pdp-my-choice"]`).trigger("click");
  }
  else{
    $(`label[for="new-pdp-chef-choice"]`).trigger("click");
  }
})

$(document).on("change", ".new-pdp-mobile-sp-inp", function(){
  $(".new-pdp-box-footer-btn").attr("data-selling-plan", $(this).val());
})

$(document).on("click", ".cc__columnitemcontainer-item-link", function(e){
  if($(window).width() <= 480){
    e.preventDefault();
    $(".cc__columnitemcontainer-item-link").removeClass("new-act");
    $(this).addClass("new-act");
    $(".new-stick-multi-btn").removeClass("inactive");
    $(".new-stick-multi-btn span").text($(this).attr("data-title"));
  }
})

$(document).on("click", ".new-stick-multi-btn", function(){
  location.href = $(".cc__columnitemcontainer-item-link.new-act").attr("href");
})


function debounce(fn, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}


$(document).on("input", ".new-blog-search-inp", debounce(function(){
  let query = $(this).val().trim();
  if(query.length > 0){
    $(".new-blog-right").hide();
    $(".new-blog-right-search-results").addClass("active").addClass("new-load").empty();
    $.ajax({
      type: "GET",
      url: `/search?q=${encodeURIComponent(query)}&view=ajax`,
      success: function(result){
        $(".new-blog-right-search-results").html(result).removeClass("new-load");
      }
    });
  }
  else{
    $(".new-blog-right-search-results").removeClass("active").empty();
    $(".new-blog-right").show();
  }
}, 500));


$(document).on("change", ".new-blog-menu-select", function(){
  let url = $(this).find("option:selected").attr("data-url");
  if(url){
    window.location.href = url;
  }
});